import React from 'react';
import { createRoot } from 'react-dom/client';

export type RenderFunction = () => React.ReactNode;

export const getRenderPropValue = (propValue?: React.ReactNode | RenderFunction): React.ReactNode => {
    if (!propValue) {
        return null;
    }

    const isRenderFunction = typeof propValue === 'function';
    if (isRenderFunction) {
        return (propValue as RenderFunction)();
    }

    return propValue;
};

export function renderLayerDom(element: React.ReactElement) {
    const div = document.createElement('div');
    div.style.opacity = '0';
    div.style.pointerEvents = 'none';
    document.body.appendChild(div);

    createRoot(div).render(element);

    return () => {
        div.remove();
    };
}

interface IPointStyle {
    element: {
        tag: any;
        attrs: any;
    };
}

export const renderPointStyle = (pointStyle: IPointStyle, style: React.CSSProperties = {}) => {
    return renderSvgChild(pointStyle.element.tag, pointStyle.element.attrs, style);
};

export const renderSvgChild = (Tag: React.ElementType, attrs: any = {}, style: React.CSSProperties = {}) => {
    if (!Tag) return null;
    return (
        <g style={{ ...style }}>
            <Tag {...attrs} />
        </g>
    );
};
